module.exports = __webpack_public_path__ + "4f532ecc1407788fd13c4211daa2bc0b.ttf";